import axios from 'axios';

export const getCategoriesAPI = () => axios.get(`{server}/admin/categories`).then(res => res.data.success)